import styled from '@emotion/styled';

export const Divider = styled.div`
  padding-right: 16px;
  border-right: 1px solid ${({ theme }) => theme.colors.zinc_200};
  margin-right: 16px;
`;
